import bangla from "./../../../assets/images/bangla.png";
import kannada from "./../../../assets/images/kannada.png";
import tamil from "./../../../assets/images/tamil.png";
import gujarati from "./../../../assets/images/gujarati.png";
import hindi from "./../../../assets/images/hindi.png";
import english from "./../../../assets/images/english.png";

export const languageOptions = [
  {
    value: "english",
    label: "English",
    recordingImage: english,
    voice: "shimmer",
    languageCode: "en",
  },
  {
    value: "hindi",
    label: "हिंदी",
    recordingImage: hindi,
    voice: "shimmer",
    languageCode: "hi",
  },
  {
    value: "marathi",
    label: "मराठी",
    recordingImage: hindi,
    voice: "shimmer",
    languageCode: "mr",
  },
  {
    value: "gujarati",
    label: "ગુજરાતી",
    recordingImage: gujarati,
    voice: "shimmer",
    languageCode: "gu",
  },
  {
    value: "kannada",
    label: "ಕನ್ನಡ",
    recordingImage: kannada,
    voice: "shimmer",
    languageCode: "kn",
  },
  {
    value: "tamil",
    label: "தமிழ்",
    recordingImage: tamil,
    voice: "shimmer",
    languageCode: "ta",
  },
  {
    value: "telugu",
    label: "తెలుగు",
    recordingImage: english,
    voice: "shimmer",
    languageCode: "te",
  },
  {
    value: "bangla",
    label: "Bangla",
    recordingImage: bangla,
    voice: "shimmer",
    languageCode: "bn",
  },
];

export const SC_LOGIN_CREDENTIALS = {
  username: "tatvacare",
  password: "tatvapractice",
};

export const LangSpecificMsg = {
  english: {
    lable: "English",
    hello: "Hey there",
    mira: "I'm {name}",
    doctor: "Doctor's AI Assistant!",
    aboutSymptoms:
      "Tell me about your symptoms and I'll securely share them with the doctor for better & faster care.",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "Book Appointment",
    successAppoinment: "You’ve successfully booked your appointment",
    cancel: "Cancel",
    editAppoitment: "Edit Appointment",
    male: "Male",
    female: "Female",
    agentSpeaking: "Agent Speaking",
    listening: "Listening",
    loading: "Loading",
    selectSpecialty: "Select specialty",
    selectSlot: "Select Preferred Time Slot",
    confirmSlot: "Confirm Slot",
    addSymptoms: "Add Symptoms",
    shareSymptomsInfo:
      "Please share your symptoms. These details are essential for your doctor to make an accurate diagnosis.",
    yesSubmitDoctor: "Yes, Submit to Doctor",
    submitToDoctor: "Submit to Doctor",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "No, I want to add more",
    likeToDo: "What would you like to do?",
    restartConversation:
      "You can restart the conversation from the beginning or submit your current details to the doctor.",
    fromBeginning: "Restart from Beginning",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "Are you sure you want to restart?",
    deleteInfo:
      "All the information you’ve entered so far will be deleted and can’t be recovered.You’ll need to enter your symptoms again from scratch.",
    yesRestart: "Yes, Restart",
    logoutConfirmation: "Are you sure you want to log out?",
    logout: "Yes, Log out",
    stay: "No, Stay",
    rescheduleAppointment: "Reschedule Appointment",
  },
  hindi: {
    lable: "हिंदी",
    hello: "नमस्ते",
    mira: "मैं {name} हूँ",
    doctor: "डॉक्टर की ए आई सहायक!",
    aboutSymptoms:
      "Doctor’s AI Assistant. Tell me about your symptoms, and I’ll securely share them with the doctor for faster & better care",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "Book Appointment",
    successAppoinment: "You’ve successfully booked your appointment",
    cancel: "Cancel",
    editAppoitment: "Edit Appointment",
    male: "Male",
    female: "Female",
    agentSpeaking: "Agent Speaking",
    listening: "Listening",
    loading: "Loading",
    selectSpecialty: "Select specialty",
    selectSlot: "Select Preferred Time Slot",
    confirmSlot: "Confirm Slot",
    addSymptoms: "Add Symptoms",
    shareSymptomsInfo:
      "Please share your symptoms. These details are essential for your doctor to make an accurate diagnosis.",
    yesSubmitDoctor: "Yes, Submit to Doctor",
    submitToDoctor: "Submit to Doctor",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "No, I want to add more",
    likeToDo: "What would you like to do?",
    restartConversation:
      "You can restart the conversation from the beginning or submit your current details to the doctor.",
    fromBeginning: "Restart from Beginning",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "Are you sure you want to restart?",
    deleteInfo:
      "All the information you’ve entered so far will be deleted and can’t be recovered.You’ll need to enter your symptoms again from scratch.",
    yesRestart: "Yes, Restart",
    logoutConfirmation: "Are you sure you want to log out?",
    logout: "Yes, Log out",
    stay: "No, Stay",
    rescheduleAppointment: "Reschedule Appointment",
  },
  marathi: {
    lable: "मराठी",
    hello: "नमस्कार",
    mira: "मी {name} आहे",
    doctor: "डॉक्टरांची एआय सहाय्यक!",
    aboutSymptoms:
      "Doctor’s AI Assistant. Tell me about your symptoms, and I’ll securely share them with the doctor for faster & better care",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "अपॉइंटमेंट बुक करा",
    successAppoinment: "आपण यशस्वीरित्या आपले अपॉइंटमेंट बुक केले आहे",
    cancel: "रद्द करा",
    editAppoitment: "अपॉइंटमेंट संपादित करा",
    male: "पुरुष",
    female: "महिला",
    agentSpeaking: "एजंट बोलत आहे",
    listening: "ऐकत आहे",
    loading: "लोड होत आहे",
    selectSpecialty: "कृपया विशेषज्ञ निवडा",
    selectSlot: "इच्छित वेळ स्लॉट निवडा",
    confirmSlot: "स्लॉट निश्चित करा",
    addSymptoms: "लक्षणे जोडा",
    shareSymptomsInfo:
      "कृपया आपली लक्षणे शेअर करा. योग्य निदानासाठी ही माहिती डॉक्टरांसाठी आवश्यक आहे.",
    yesSubmitDoctor: "होय, डॉक्टरांना सबमिट करा",
    submitToDoctor: "डॉक्टरांना सबमिट करा",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "नाही, मला अजून माहिती जोडायची आहे",
    likeToDo: "आपण काय करू इच्छिता?",
    restartConversation:
      "आपण संभाषणाची सुरुवात पासून पुन्हा करू शकता किंवा सध्याची माहिती डॉक्टरांना सबमिट करू शकता.",
    fromBeginning: "सुरुवातीपासून पुन्हा सुरू करा",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "आपण पुन्हा सुरू करू इच्छिता याबद्दल खात्री आहे का?",
    deleteInfo:
      "आतापर्यंत भरलेली सर्व माहिती हटवली जाईल आणि ती पुन्हा मिळवता येणार नाही. आपल्याला लक्षणे पुन्हा नव्याने भरावी लागतील.",
    yesRestart: "होय, पुन्हा सुरू करा",
    logoutConfirmation: "आपण लॉग आउट करू इच्छिता याची खात्री आहे का?",
    logout: "होय, लॉग आउट करा",
    stay: "नाही, तसंच राहू द्या",
    rescheduleAppointment: "Reschedule Appointment",
  },
  kannada: {
    lable: "ಕನ್ನಡ",
    hello: "ನಮಸ್ಕಾರ",
    mira: "ನಾನು {name}",
    doctor: "ಡಾಕ್ಟರ್ ಅವರ AI ಸಹಾಯಕಿ!",
    aboutSymptoms:
      "Doctor’s AI Assistant. Tell me about your symptoms, and I’ll securely share them with the doctor for faster & better care",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
    successAppoinment: "ನಿಮ್ಮ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಯಶಸ್ವಿಯಾಗಿ ಬುಕ್ ಆಗಿದೆ",
    cancel: "ರದ್ದುಮಾಡಿ",
    editAppoitment: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ತಿದ್ದುಪಡಿ ಮಾಡಿ",
    male: "ಪುರುಷ",
    female: "ಮಹಿಳೆ",
    agentSpeaking: "ಏಜೆಂಟ್ ಮಾತನಾಡುತ್ತಿದ್ದಾರೆ",
    listening: "ಕೇಳುತ್ತಿದ್ದಾರೆ",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ",
    selectSpecialty: "ವಿಶೇಷತೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    selectSlot: "ಆದ್ಯತೆಯ ಸಮಯ ಸ್ಲಾಟ್ ಆಯ್ಕೆಮಾಡಿ",
    confirmSlot: "ಸ್ಲಾಟ್ ಅನ್ನು ದೃಢೀಕರಿಸಿ",
    addSymptoms: "ರೋಗಲಕ್ಷಣಗಳನ್ನು ಸೇರಿಸಿ",
    shareSymptomsInfo:
      "ದಯವಿಟ್ಟು ನಿಮ್ಮ ರೋಗಲಕ್ಷಣಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಿ. ನಿಮ್ಮ ವೈದ್ಯರು ನಿಖರವಾದ ರೋಗನಿರ್ಣಯವನ್ನು ಮಾಡಲು ಈ ವಿವರಗಳು ಅತ್ಯಗತ್ಯ",
    yesSubmitDoctor: "ಹೌದು, ವೈದ್ಯರಿಗೆ ಸಲ್ಲಿಸಿ",
    submitToDoctor: "ವೈದ್ಯರಿಗೆ ಸಲ್ಲಿಸಿ",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "ಇಲ್ಲ, ನಾನು ಇನ್ನಷ್ಟು ಸೇರಿಸಲು ಬಯಸುತ್ತೇನೆ",
    likeToDo: "ನೀವು ಏನು ಮಾಡಲು ಬಯಸುತ್ತೀರಿ?",
    restartConversation:
      "ನೀವು ಸಂಭಾಷಣೆಯನ್ನು ಮೊದಲಿನಿಂದಲೂ ಪುನರಾರಂಭಿಸಬಹುದು ಅಥವಾ ನಿಮ್ಮ ಪ್ರಸ್ತುತ ವಿವರಗಳನ್ನು ವೈದ್ಯರಿಗೆ ಸಲ್ಲಿಸಬಹುದು.",
    fromBeginning: "ಪ್ರಾರಂಭದಿಂದ ಮರುಪ್ರಾರಂಭಿಸಿ",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "ನೀವು ಮರುಪ್ರಾರಂಭಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
    deleteInfo:
      "ನೀವು ಇಲ್ಲಿಯವರೆಗೆ ನಮೂದಿಸಿದ ಎಲ್ಲಾ ಮಾಹಿತಿಯನ್ನು ಅಳಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಅದನ್ನು ಮರುಪಡೆಯಲು ಸಾಧ್ಯವಿಲ್ಲ. ನೀವು ಮೊದಲಿನಿಂದಲೂ ನಿಮ್ಮ ರೋಗಲಕ್ಷಣಗಳನ್ನು ಮತ್ತೆ ನಮೂದಿಸಬೇಕಾಗುತ್ತದೆ.",
    yesRestart: "ಹೌದು, ಮರುಪ್ರಾರಂಭಿಸಿ",
    logoutConfirmation: "ನೀವು ಲಾಗ್ ಔಟ್ ಮಾಡಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
    logout: "ಹೌದು, ಲಾಗ್ ಔಟ್ ಮಾಡಿ",
    stay: "ಇಲ್ಲ, ಇರಿ",
    rescheduleAppointment: "Reschedule Appointment",
  },
  tamil: {
    lable: "தமிழ்",
    hello: "வணக்கம்",
    mira: "நான் மிரா",
    doctor: "டாக்டரின் AI உதவியாளர்!",
    aboutSymptoms:
      "Doctor’s AI Assistant. Tell me about your symptoms, and I’ll securely share them with the doctor for faster & better care",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "முன்பதிவு செய்யவும்",
    successAppoinment: "உங்கள் முன்பதிவு வெற்றிகரமாக செய்யப்பட்டது",
    cancel: "ரத்து செய்யவும்",
    editAppoitment: "முன்பதிவைத் திருத்தவும்",
    male: "ஆண்",
    female: "பெண்",
    agentSpeaking: "ஏஜெண்ட் பேசுகிறார்",
    listening: "கேட்கிறேன்",
    loading: "செயலில் உள்ளது",
    selectSpecialty: "செயலில் உள்ளது",
    selectSlot: "விருப்பமான நேரத்தைத் தேர்வு செய்யவும்",
    confirmSlot: "நேரத்தை உறுதிப்படுத்தவும்",
    addSymptoms: "அறிகுறிகளை கூறவும்",
    shareSymptomsInfo:
      "தயவுசெய்து உங்கள் அறிகுறிகளை பகிரவும். சரியான நோய் கண்டறிதல் செய்ய உங்கள் மருத்துவருக்கு இந்த விவரங்கள் அவசியம் தேவை.",
    yesSubmitDoctor: "ஆம், மருத்துவருக்கு சமர்ப்பிக்கவும்",
    submitToDoctor: "மருத்துவருக்கு சமர்ப்பிக்கவும்",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "இல்லை, மேலும் சேர்க்க விரும்புகிறேன்",
    likeToDo: "நீங்கள் என்ன செய்ய விரும்புகிறீர்கள்?",
    restartConversation:
      "நீங்கள் உரையாடலை ஆரம்பத்திலிருந்து மீண்டும் தொடங்கலாம் அல்லது உங்கள் தற்போதைய விவரங்களை மருத்துவருக்கு சமர்ப்பிக்கலாம்.",
    fromBeginning: "ஆரம்பத்திலிருந்து மீண்டும் தொடங்கவும்",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "மீண்டும் தொடங்க விரும்புகிறீர்களா?",
    deleteInfo:
      "இதுவரை நீங்கள் உள்ளிட்ட அனைத்து தகவலும் நீக்கப்படும் மற்றும் மீட்டெடுக்க முடியாது. உங்கள் அறிகுறிகளை மீண்டும் முதல் முறையாக பதிவு செய்ய வேண்டும்.",
    yesRestart: "ஆம், மீண்டும் தொடங்கவும்",
    logoutConfirmation: "நீங்கள் நிச்சயமாக வெளியேற விரும்புகிறீர்களா?",
    logout: "ஆம், வெளியேறு",
    stay: "இல்லை, தொடரவும்",
    rescheduleAppointment: "Reschedule Appointment",
  },
  telugu: {
    lable: "తెలుగు",
    hello: "నమస్తే",
    mira: "నేను {name}",
    doctor: "నేను మీ డాక్టర్ యొక్క ఎయ్ ఐ సహాయకురాలిని!",
    aboutSymptoms:
      "Doctor’s AI Assistant. Tell me about your symptoms, and I’ll securely share them with the doctor for faster & better care",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "అపాయింట్మెంట్ బుక్ చేయండి",
    successAppoinment: "మీ అపాయింట్మెంట్ విజయవంతంగా బుక్ అయింది",
    cancel: "రద్దు చేయండి",
    editAppoitment: "అపాయింట్‌మెంట్‌ని సవరించండి",
    male: "పురుషుడు",
    female: "స్త్రీ",
    agentSpeaking: "ఏజెంట్ మాట్లాడుతున్నారు",
    listening: "వింటున్నాను",
    loading: "లోడ్ అవుతోంది",
    selectSpecialty: "ప్రత్యేకతను ఎంచుకోండి",
    selectSlot: "ఇష్టపడే సమయ స్లాట్‌ను ఎంచుకోండి",
    confirmSlot: "స్లాట్‌ను నిర్ధారించండి",
    addSymptoms: "లక్షణాలను జోడించండి",
    shareSymptomsInfo:
      "దయచేసి మీ లక్షణాలను పంచుకోండి. మీ వైద్యుడు ఖచ్చితమైన రోగ నిర్ధారణ చేయడానికి ఈ వివరాలు చాలా అవసరం.",
    yesSubmitDoctor: "అవును, డాక్టర్‌కు సమర్పించండి",
    submitToDoctor: "డాక్టర్‌కు సమర్పించండి",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "లేదు, నేను మరిన్ని జోడించాలనుకుంటున్నాను",
    likeToDo: "మీరు ఏమి చేయాలనుకుంటున్నారు?",
    restartConversation:
      "మీరు సంభాషణను ప్రారంభం నుండి పునఃప్రారంభించవచ్చు లేదా మీ ప్రస్తుత వివరాలను వైద్యుడికి సమర్పించవచ్చు.",
    fromBeginning: "ప్రారంభం నుండి పునఃప్రారంభించండి",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "మీరు ఖచ్చితంగా పునఃప్రారంభించాలనుకుంటున్నారా?",
    deleteInfo:
      "మీరు ఇప్పటివరకు నమోదు చేసిన మొత్తం సమాచారం తొలగించబడుతుంది మరియు తిరిగి పొందలేరు. మీరు మీ లక్షణాలను మొదటి నుండి మళ్ళీ నమోదు చేయాలి.",
    yesRestart: "అవును, పునఃప్రారంభించండి",
    logoutConfirmation: "మీరు ఖచ్చితంగా లాగ్ అవుట్ చేయాలనుకుంటున్నారా?",
    logout: "అవును, లాగ్ అవుట్ చేయండి",
    stay: "లేదు, ఉండండి",
    rescheduleAppointment: "Reschedule Appointment",
  },
  gujarati: {
    lable: "ગુજરાતી",
    hello: "નમસ્તે",
    mira: "હું મીરા છું",
    doctor: "ડૉક્ટર ની એ.આઈ. સહાયક!",
    aboutSymptoms:
      "Doctor’s AI Assistant. Tell me about your symptoms, and I’ll securely share them with the doctor for faster & better care",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "Book Appointment",
    successAppoinment: "You’ve successfully booked your appointment",
    cancel: "Cancel",
    editAppoitment: "Edit Appointment",
    male: "Male",
    female: "Female",
    agentSpeaking: "Agent Speaking",
    listening: "Listening",
    loading: "Loading",
    selectSpecialty: "Select specialty",
    selectSlot: "Select Preferred Time Slot",
    confirmSlot: "Confirm Slot",
    addSymptoms: "Add Symptoms",
    shareSymptomsInfo:
      "Please share your symptoms. These details are essential for your doctor to make an accurate diagnosis.",
    yesSubmitDoctor: "Yes, Submit to Doctor",
    submitToDoctor: "Submit to Doctor",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "No, I want to add more",
    likeToDo: "What would you like to do?",
    restartConversation:
      "You can restart the conversation from the beginning or submit your current details to the doctor.",
    fromBeginning: "Restart from Beginning",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "Are you sure you want to restart?",
    deleteInfo:
      "All the information you’ve entered so far will be deleted and can’t be recovered.You’ll need to enter your symptoms again from scratch.",
    yesRestart: "Yes, Restart",
    logoutConfirmation: "Are you sure you want to log out?",
    logout: "Yes, Log out",
    stay: "No, Stay",
    rescheduleAppointment: "Reschedule Appointment",
  },
  bangla: {
    lable: "bangla",
    hello: "Hey there",
    mira: "I'm {name}",
    doctor: "Doctor's AI Assistant!",
    aboutSymptoms:
      "Doctor’s AI Assistant. Tell me about your symptoms, and I’ll securely share them with the doctor for faster & better care",
    tapToTalk: "Type your symptoms here",
    tapToBookAppointment: "Type to book appointment",
    aboutAppointment:
      "Doctor’s AI Assistant helping to book your appointment and share your symptoms securely with the doctor!",
    bookAppointment: "Book Appointment",
    successAppoinment: "You’ve successfully booked your appointment",
    cancel: "Cancel",
    editAppoitment: "Edit Appointment",
    male: "Male",
    female: "Female",
    agentSpeaking: "Agent Speaking",
    listening: "Listening",
    loading: "Loading",
    selectSpecialty: "Select specialty",
    selectSlot: "Select Preferred Time Slot",
    confirmSlot: "Confirm Slot",
    addSymptoms: "Add Symptoms",
    shareSymptomsInfo:
      "Please share your symptoms. These details are essential for your doctor to make an accurate diagnosis.",
    yesSubmitDoctor: "Yes, Submit to Doctor",
    submitToDoctor: "Submit to Doctor",
    submitToDoctorInfo1: "Thanks for sharing everything so far!",
    submitToDoctorInfo2:
      "Is there anything else you’d like to mention to the doctor, or can we go ahead & submit your symptoms?",
    addMore: "No, I want to add more",
    likeToDo: "What would you like to do?",
    restartConversation:
      "You can restart the conversation from the beginning or submit your current details to the doctor.",
    fromBeginning: "Restart from Beginning",
    noAddEditDetails: "No, I want to add/edit details",
    restart: "Are you sure you want to restart?",
    deleteInfo:
      "All the information you’ve entered so far will be deleted and can’t be recovered.You’ll need to enter your symptoms again from scratch.",
    yesRestart: "Yes, Restart",
    logoutConfirmation: "Are you sure you want to log out?",
    logout: "Yes, Log out",
    stay: "No, Stay",
    rescheduleAppointment: "Reschedule Appointment",
  },
};

export const OPENAI_SUPPORTED_LANGUAGES = [
  "af",
  "ar",
  "az",
  "be",
  "bg",
  "bs",
  "ca",
  "cs",
  "cy",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "kk",
  "kn",
  "ko",
  "lt",
  "lv",
  "mi",
  "mk",
  "mr",
  "ms",
  "ne",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "sw",
  "ta",
  "th",
  "tl",
  "tr",
  "uk",
  "ur",
  "vi",
  "zh",
];

export const MOBILE_NUMBER = "mobileNumber";
export const JWT_TOKEN = "jwtToken";
export const TYPE = "type";
export const FROM = "from";
export const LANGUAGE = "language";
export const INPUT_AUDIO_NOISE_REDUCTION_TYPE = {
  FAR_FIELD: "far_field",
  NEAR_FIELD: "near_field",
};
export const ENABLE_VOICE_MODE = true;
export const DEFAULT_AGENT_NAME = "Mira";
export const DEFAULT_VOICE = "shimmer";
export const DEFAULT_GENDER = "female";
